/**
 * Thin wrapper around Azure Application Insights.
 *
 * The SDK is loaded via CDN script tag in public/index.html.
 * When the connection string env var is empty (local dev), every
 * function here is a silent no-op.
 */

function getInsights() {
  return window.appInsights;
}

/**
 * Track a custom event (e.g. training_started, slide_viewed).
 * @param {string} name  - Event name
 * @param {Object} [properties] - Key/value custom properties
 */
export function trackEvent(name, properties) {
  const ai = getInsights();
  if (!ai) return;
  ai.trackEvent({ name }, properties);
}

/**
 * Track a page view (called on SPA route change).
 * @param {string} name - Friendly page name
 * @param {string} uri  - URL path (e.g. /training)
 */
export function trackPageView(name, uri) {
  const ai = getInsights();
  if (!ai) return;
  ai.trackPageView({ name, uri });
}
